import { type Language, t } from '../i18n';

interface LanguageSelectorProps {
  language: Language;
  onLanguageChange: (lang: Language) => void;
}

export function LanguageSelector({ language, onLanguageChange }: LanguageSelectorProps) {
  return (
    <div
      className="flex items-center gap-2"
      role="group"
      aria-label={t(language, 'language.select')}
    >
      <button
        onClick={() => onLanguageChange('en')}
        className={`px-3 py-1.5 rounded-md text-sm font-medium transition-colors ${
          language === 'en'
            ? 'bg-primary-600 text-white'
            : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
        }`}
        aria-label="English"
        aria-pressed={language === 'en'}
      >
        {t(language, 'language.en')}
      </button>
      <button
        onClick={() => onLanguageChange('it')}
        className={`px-3 py-1.5 rounded-md text-sm font-medium transition-colors ${
          language === 'it'
            ? 'bg-primary-600 text-white'
            : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
        }`}
        aria-label="Italiano"
        aria-pressed={language === 'it'}
      >
        {t(language, 'language.it')}
      </button>
    </div>
  );
}
